import Lib from '../../../commons/lib';

export default class Service {
    static jegyUrl = window.location.origin + '/api/jegy/';

    static helyszinUrl = window.location.origin + '/api/helyszin/';

    static cikkUrl = window.location.origin + '/api/cikk/';

    static configUrl = window.location.origin + '/api/config/';

    static jegytermekUrl = window.location.origin + '/api/jegytermek/';

    static penzugyUrl = window.location.origin + '/api/penzugykozos/';

    // JEGY START

    static listJegy(fnDone) {
        Lib.MicroServices.requestService([{
            method: 'GET',
            url: Service.jegyUrl + 'jegy/list',
            args: { requestType: 'jegy-list-get' },
        }], fnDone);
    }

    static addJegy(jegyObj, fnDone) {
        Lib.MicroServices.requestService([{
            method: 'POST',
            url: Service.jegyUrl + 'jegy',
            args: { requestType: 'jegy-post' },
            data: jegyObj
        }], fnDone);
    }

    static modifyJegy(jegyObj, fnDone) {
        Lib.MicroServices.requestService([{
            method: 'PUT',
            url: Service.jegyUrl + 'jegy',
            args: { requestType: 'jegy-put' },
            data: jegyObj
        }], fnDone);
    }

    static deleteJegy(id, fnDone) {
        Lib.MicroServices.requestService([{
            method: 'DELETE',
            url: Service.jegyUrl + 'jegy',
            args: { requestType: 'jegy-delete' },
            params: { id: id }
        }], fnDone);
    }

    static listJegyEnums(fnDone) {
        Lib.MicroServices.requestService([{
            method: 'GET',
            url: Service.jegyUrl + 'jegy/enum',
            args: { requestType: 'jegy-enum-list' }
        }], fnDone);
    }

    static listJegyKategoria(id, fnDone) {
        Lib.MicroServices.requestService([{
            method: 'GET',
            url: Service.jegyUrl + 'jegy/kategoria/list',
            args: { requestType: 'jegy-kategoria-list' },
            params: { id: id }
        }], fnDone);
    }

    static addJegyKategoria(jegyKategoriaObj, fnDone) {
        Lib.MicroServices.requestService([{
            method: 'POST',
            url: Service.jegyUrl + 'jegy/kategoria',
            args: { requestType: 'jegy-kategoria-post' },
            data: jegyKategoriaObj
        }], fnDone);
    }

    static modifyJegyKategoria(jegyKategoriaObj, fnDone) {
        Lib.MicroServices.requestService([{
            method: 'PUT',
            url: Service.jegyUrl + 'jegy/kategoria',
            args: { requestType: 'jegy-kategoria-put' },
            data: jegyKategoriaObj
        }], fnDone);
    }

    static deleteJegyKategoria(id, fnDone) {
        Lib.MicroServices.requestService([{
            method: 'DELETE',
            url: Service.jegyUrl + 'jegy/kategoria',
            args: { requestType: 'jegy-kategoria-delete' },
            params: { id: id }
        }], fnDone);
    }

    static listArkategoriak(fnDone) {
        Lib.MicroServices.requestService([{
            method: 'GET',
            url: Service.jegyUrl + 'jegy/listarkategoria',
            args: { requestType: 'jegy-listarkategoria-get' },
        }], fnDone);
    }

    static getJegyAngolNyelv(fnDone) {
        Lib.MicroServices.requestService([{
          method: 'GET',
          url: Service.jegyUrl + 'jegy/parameter/angolnyelv',
          args: { requestType: 'jegy-parameter-angolnyelv' },
        }], fnDone);
    }

    // JEGY END

    // HELYSZÍN START

    static listHelyszinSelect(fnDone) {
        Lib.MicroServices.requestService([{
            method: 'GET',
            url: Service.helyszinUrl + 'helyszin/list/select',
            args: { requestType: 'helyszin-list-select' },
            params: { tipus: "SAJAT"}
        }], fnDone);
    }

    // HELYSZÍN END

    // CIKK START

    static getAktivCikkek(text, fnDone) {
        Lib.MicroServices.requestService([{
            method: 'GET',
            url: Service.cikkUrl + 'cikk/getaktiv',
            args: { requestType: 'cikk-getaktiv-get' },
            params: { text: text }
        }], fnDone);
    }

    // CIKK END

    // CONFIG START

    static existsMS(msNev, fnDone) {
        Lib.MicroServices.requestService([{
            method: 'GET',
            url: Service.jegyUrl + 'jegy/existsMS',
            args: { requestType: 'jegy-msexists-get' },
            params: { msNev: msNev }
        }], fnDone);
    }

    // CONFIG END

    // PENZUGY START

    static listAktivPenznem(fnDone) {
        Lib.MicroServices.requestService([{
            method: 'GET',
            url: Service.penzugyUrl + 'penznem/aktiv',
            args: { requestType: 'penznem-aktiv' }
        }], fnDone);
    }

    // PENZUGY END
}